<template>
	<div class="summary-tag" :class="className">
		<div class="detail-item">
			<div class="label-cont">
				<div class="label-band">{{ tagLabel }}</div>
			</div>
			<div class="text-cont">
				<div class="summary-text">{{ tagText }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "summary-tag",
	props: {
		className: String,
		tagLabel: String,
		tagText: String,
	},
};
</script>

<style scoped lang="scss">
.summary-tag {
	.detail-item {
		display: flex;
		flex-direction: row;
		padding-bottom: 16px;
		.header4 {
			color: #1a1a1a;
		}
		.label-cont {
			// width: 100px;
			width: 114px;
			display: flex;
		}
		.label-band {
			background: #f6f4f3;
			border-radius: 7.5px;
			padding: 4px 9px;
			font-style: normal;
			font-weight: normal;
			// font-size: 12px;
			font-size: 1rem;
			line-height: 19px;
			color: #595959;
		}
		.summary-text {
			font-style: normal;
			font-weight: 500;
			// font-size: 14px;
			font-size: 1.2rem;
			line-height: 27px;
		}
	}
}
.summary-tag:nth-child(even) .detail-item .label-cont {
	width: 135px;
}
@media screen and (max-width: 414px) {
	.summary-tag {
		.detail-item .label-cont {
			width: 140px;
		}
	}
	// .summary-tag:nth-child(even) .detail-item .label-cont {
	// 	width: 140px;
	// }
}
</style>